import 'slick-carousel';

$('.slider-reviews').each(function() {
  $(this)
    .find('.slider__slides')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
    });
});
